import React, { useEffect, useRef } from 'react';
import './WIFI_Icon.scss';

// 測試用
// import { WIFI_icon } from './../admin/Index/MainPage'; // WIFI-icon

const WIFIIcon = React.memo((props) => {
    /**
     * props的key值
     * rssi
     * styles 修改 style值
     * - wifi_group: 針對 wifiGroup
     * - wifi_item_1: 針對 wifiItem1 
     * - wifi_item_2: 針對 wifiItem2 
     * - wifi_item_3: 針對 wifiItem3 
     * - wifi_item_4: 針對 wifiItem4 
     */
    const wifiGroup = useRef(null);
    const wifiItem1 = useRef(null);
    const wifiItem2 = useRef(null);
    const wifiItem3 = useRef(null);
    const wifiItem4 = useRef(null);

    useEffect(() => {
        // componentDidMount | componentDidUpdate
        const toChangeElementStyle = function (element) {
            if (element !== undefined && element !== null) {
                if (Object.keys(element).length !== 0) {
                    for (const key of Object.keys(element)) {
                        for (const [key1, value1] of Object.entries(element[key])) {
                            switch (key) {
                                // wifi_group: wifi-group 
                                case "wifi_group":
                                    wifiGroup.current.style[key1] = value1;
                                    break;
                                // // wifi_item_1: wifi-item1 第一層(最頂層)
                                case "wifi_item_1":
                                    wifiItem1.current.style[key1] = value1;
                                    break;
                                // // wifi_item_2: wifi-item2 第二層
                                case "wifi_item_2":
                                    wifiItem2.current.style[key1] = value1;
                                    break;
                                // // wifi_item_3: wifi-item3 第三層
                                case "wifi_item_3":
                                    wifiItem3.current.style[key1] = value1;
                                    break;
                                // // wifi_item_4: wifi-item4 第四層(最內層)
                                case "wifi_item_4":
                                    wifiItem4.current.style[key1] = value1;
                                    break;
                                default :
                                    wifiItem4.current.style[key1] = value1;
                                    break;
                            }
                        }
                    }
                }
            }
        };
        if (props.styles !== undefined && props.styles !== null) {
            toChangeElementStyle(props.styles)
        }

        return () => {
            // componentWillUnmount
        };
    }, [props]);

    return (
        <>
            <div className={`wifi-group pos-a mode-radar
            ${props.size !== null || props.size !== undefined ? props.size : ""}
            ${props.rssi === null || props.rssi === undefined
                    ? "rssi_none"
                    : props.rssi > -50
                        ? "rssi_exc"
                        : props.rssi > -60
                            ? "rssi_good"
                            : props.rssi > -70
                                ? "rssi_fair"
                                : props.rssi <= -70
                                    ? "rssi_weak"
                                    : ""

                }`}
                ref={wifiGroup}
            >
                {/* Wifi 最外層 */}
                <div className={`wifi-item wifi-item1 ${props.rssi > -50
                    ? "active"
                    : ""
                    }`}
                    ref={wifiItem1}>
                    <div className={`wifi-item wifi-item2 ${props.rssi > -60
                        ? "active"
                        : ""
                        }`}
                        ref={wifiItem2}>
                        <div className={`wifi-item wifi-item3 ${props.rssi > -70
                            ? "active"
                            : ""
                            }`}
                            ref={wifiItem3}>
                            {/* Wifi 最內層 */}
                            <div className={`wifi-item wifi-item4 
                            ${props.rssi !== null && props.rssi !== undefined && props.rssi > -100
                                    ? "active"
                                    : ""
                                }`}
                                ref={wifiItem4}></div>
                        </div>
                    </div>
                </div>

                {/* Wifi sign: x */}
                <div className={`wifi_sign 
                ${props.rssi !== null && props.rssi !== undefined && props.rssi > -100
                        ? ""
                        : "rssi_none"
                    }`}></div>

            </div>
        </>
    )
})

export default WIFIIcon;